import styled from "styled-components";
import { Button } from "../Button";
import { Wrapper } from "../UseState&props/styles";

export const NewWrapper = styled(Wrapper)`
  background: #2991e6
`;

export const NewButton = styled(Button)`
  background: #2991e6;
`;
